export interface MinimalMetoroConfig {
    enableLogs: boolean;
}

export interface MetoroConfig {
    isOnprem: boolean;
    isMinimal: boolean;
    minimalMetoroConfig: MinimalMetoroConfig | null;
}

export const defaultConfig: MetoroConfig = {
    isOnprem: false,
    isMinimal: false,
    minimalMetoroConfig: null
}; 